declare namespace $ {

	type $mol_button_minor__sub_shm_hitalama_select_list_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_select_list_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_select_list['add_option'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__click_shm_hitalama_select_list_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_select_list['delete'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_select_list_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	export class $shm_hitalama_select_list extends $mol_select_list {
		Add_option_icon( ): $mol_icon_plus
		add_option( next?: any ): any
		delete( id: any, next?: any ): any
		Delete_icon( id: any): $mol_icon_trash_can
		Add_option( ): $mol_button_minor
		options( next?: readonly(string)[] ): readonly(string)[]
		pick_enabled( ): boolean
		Option_delete( id: any): $mol_button_minor
	}
	
}

//# sourceMappingURL=list.view.tree.d.ts.map